import RetryPaymentPage from "./retryPayment";

export default RetryPaymentPage;
